// extracted by mini-css-extract-plugin
module.exports = {"actionContainer":"Pricetemplates_actionContainer__1vGdb","pricetemplatesLayout":"Pricetemplates_pricetemplatesLayout__2bVaX"};